<template>
  <div id="app">
    <router-view :class="[$route.meta.showTabs ? 'main' : '']" />

    <NavBar v-if="$route.meta.showTabs" />
    <transition name="fade">
      <div class="customer-float" v-show="isVisible">
        <div class="customer-text" @click="customerDialogVirsble = true">
          <img src="@/assets/images/ic_float_service_3.png" alt="" />
          <span>客服</span>
        </div>

        <!-- <img class="customer-img" src="@/assets/images/ic_float_service_3.png" alt=""> -->
      </div>
    </transition>

    <deskFlagAdd
      class="desk-mark"
      @deskHandle="deskHandle"
      v-if="(this.platformInfo.browserType != 'safari'  || !this.platformInfo.isBookmark) && this.platformInfo.deviceType != 'harmony'"
    />

    <customerDialog
      v-if="customerDialogVirsble"
      v-model="customerDialogVirsble"
      @handleClose="dialogClose"
    />

    <promptPopup v-if="promptPopupVirsble" v-model="promptPopupVirsble" />
    <promptPopup2 v-if="promptPopup2Virsble" v-model="promptPopup2Virsble" />
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import deskFlagAdd from "@/components/DeskFlagAdd.vue";
import { mapActions } from "vuex";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import customerDialog from "@/components/CustomerDialog";
import promptPopup from "@/components/PromptPopup";
import promptPopup2 from "@/components/PromptPopup2";
import platform from "./mixin/platform"
export default {
  name: "App",
  mixins: [platform],
  components: {
    NavBar,
    deskFlagAdd,
    customerDialog,
    promptPopup,
    promptPopup2,
  },

  data() {
    return {
      customerDialogVirsble: false,
      isVisible: true,
      scrollTimeout: null, // 定时器
      promptPopupVirsble: false,
      promptPopup2Virsble: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    // 组件销毁时移除事件监听
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    ...mapActions(["updateDeviceId"]),

    /**
     * 获取设备id
     */
    async initDeviceId() {
      const fp = await FingerprintJS.load();
      const result = await fp.get();
      const deviceId = result.visitorId;
      console.log(deviceId, "init-deviceid");
      this.updateDeviceId(deviceId);
    },

    dialogClose(action, done) {
      done();
    },

    handleScroll() {
      // 页面滚动时隐藏按钮
      this.isVisible = false;

      // 页面滚动时隐藏按钮
      this.isVisible = false;

      // 如果已经有定时器，清除掉
      if (this.scrollTimeout) {
        clearTimeout(this.scrollTimeout);
      }

      // 设置一个定时器，滚动停止后显示按钮
      this.scrollTimeout = setTimeout(() => {
        this.isVisible = true;
      }, 500); // 滚动停止150毫秒后显示按钮，可以根据需要调整
    },

    deskHandle() {
      console.log(this.platformInfo)
      if(this.platformInfo.deviceType == 'android') {
        window.location.href = 'http://wmsy666.com/H5Android'
      } else if (this.platformInfo.deviceType == 'ios' && this.platformInfo.browserType != 'safari') {
        this.promptPopupVirsble = true;
      } else if(this.platformInfo.deviceType == 'ios' && this.platformInfo.browserType == 'safari' && !this.platformInfo.isBookmark) {
        this.promptPopup2Virsble = true;
      }
      
    },
  },
};
</script>

<style lang="scss" scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  .main {
    padding-bottom: 98px;
  }

  .customer-float {
    position: fixed;
    right: 0;
    bottom: 140px;

    .customer-text {
      background: url(~@/assets/images/ic_float_service_4.png);
      background-size: 100% 100%;
      width: 36px;
      height: 100px;
      text-align: center;
      img {
        width: 22px;
        height: 18px;
        margin-top: 15px;
        margin-bottom: 8px;
      }
      span {
        display: block;
        font-family: Helvetica;
        font-size: 19px;
        color: #ffffff;
        line-height: 22px;
        width: 18px;
        margin-left: 9px;
      }
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease, transform 0.5s ease; /* 过渡时间 */
}

.fade-enter, 
.fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0; /* 隐藏时透明度为0 */
  transform: scale(0.5) translateY(20px); /* 隐藏时按钮缩小并下移 */
}

.fade-enter-to,
.fade-leave {
  opacity: 1; /* 显示时透明度为1 */
  transform: scale(1) translateY(0); /* 显示时恢复原尺寸并返回原位置 */
}
::-webkit-scrollbar {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue